import { render, staticRenderFns } from "./batch_close.vue?vue&type=template&id=6f89135c&scoped=true&"
import script from "./batch_close.vue?vue&type=script&lang=js&"
export * from "./batch_close.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f89135c",
  null
  
)

export default component.exports